<template>
  <app-select
    filter
    :items="states"
    :label="$t('status')"
    label-icon="icon-gauge"
    multiple
    hide-details
    dense
    solo
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { DEBTOR_STATE_GROUPS } from '@/modules/Debtors/statics/debtorStatus';
import formatDebtorStatus from '@/helper/filter/formatDebtorStatus';

export default {
  name: 'StatusSelect',

  computed: {
    states() {
      return Object.keys(DEBTOR_STATE_GROUPS).map((status) => ({
        label: formatDebtorStatus(status),
        value: status
      }));
    }
  }
};
</script>
